import { render, staticRenderFns } from "./SalesFigure.vue?vue&type=template&id=cca7114e&"
import script from "./SalesFigure.vue?vue&type=script&lang=js&"
export * from "./SalesFigure.vue?vue&type=script&lang=js&"
import style0 from "./SalesFigure.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports